interface TestimonialCardProps {
  category: string;
  name: string;
  text: string;
  highlight: string;
  image: string;
}

export default function TestimonialCard({ category, name, text, highlight, image }: TestimonialCardProps) {
  return (
    <article className="bg-white rounded-xl sm:rounded-2xl overflow-hidden shadow-sm hover:shadow-xl transition-all duration-500 hover:-translate-y-1 sm:hover:-translate-y-2 cursor-pointer">
      <div className="relative h-48 sm:h-64 overflow-hidden">
        <img
          src={image}
          alt={`${name} — отзыв о программе ${category}`}
          width="400"
          height="400"
          loading="lazy"
          decoding="async"
          className="w-full h-full object-cover transition-transform duration-700 hover:scale-110"
        />
        <div className="absolute top-3 sm:top-4 left-3 sm:left-4">
          <span className="inline-block px-3 sm:px-4 py-1 sm:py-1.5 bg-white/95 backdrop-blur-sm text-[#4A5D44] text-xs font-light rounded-full">
            {category}
          </span>
        </div>
      </div>

      <div className="p-5 sm:p-8">
        <div className="flex items-center gap-1 mb-3 sm:mb-4" role="img" aria-label="Рейтинг 5 из 5 звезд">
          {[...Array(5)].map((_, i) => (
            <i key={i} className="ri-star-fill text-[#F4C430] text-base sm:text-lg" aria-hidden="true"></i>
          ))}
        </div>

        <p className="text-sm sm:text-base font-light text-gray-700 leading-relaxed mb-4 sm:mb-6 line-clamp-4">
          {text}
        </p>

        <div className="pt-3 sm:pt-4 border-t border-gray-100">
          <p className="text-xs sm:text-sm font-light text-[#8B9D83] italic">
            &ldquo;{highlight}&rdquo;
          </p>
          <p className="text-xs sm:text-sm font-light text-gray-500 mt-2">
            — {name}
          </p>
        </div>
      </div>
    </article>
  );
}